var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.createFilterRequestScope = void 0;
  function createFilterRequestScope(client, {
    method
  }) {
    const requestMap = {};
    if (client.transport.type === "fallback") client.transport.onResponse?.(({
      method: method_,
      response: id,
      status,
      transport
    }) => {
      if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return id => requestMap[id] || client.request;
  }
  exports.createFilterRequestScope = createFilterRequestScope;
  //# sourceMappingURL=createFilterRequestScope.js.map
  return exports;
}